import { useEffect } from "react";
import { useOsActions, useOsFocus } from "./OsContext";
import { isTypingInInput, matchesShortcut } from "./osShortcuts";

interface UseOsShortcutsOptions {
  isSearchOpen: boolean;
  openSearch: () => void;
  closeSearch: () => void;
  toggleAniAssistant: () => void;
}

export function useOsShortcuts({
  isSearchOpen,
  openSearch,
  closeSearch,
  toggleAniAssistant,
}: UseOsShortcutsOptions): void {
  const { focusedWindowId } = useOsFocus();
  const { closeWindow } = useOsActions();

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (matchesShortcut(event, "TOGGLE_GLOBAL_SEARCH")) {
        event.preventDefault();
        if (isSearchOpen) {
          closeSearch();
        } else {
          openSearch();
        }
        return;
      }

      if (matchesShortcut(event, "TOGGLE_ANI_ASSISTANT")) {
        event.preventDefault();
        toggleAniAssistant();
        return;
      }

      if (!matchesShortcut(event, "CLOSE_ACTIVE_WINDOW")) {
        return;
      }

      if (isSearchOpen) {
        event.preventDefault();
        closeSearch();
        return;
      }

      if (isTypingInInput(event) || !focusedWindowId) {
        return;
      }

      event.preventDefault();
      closeWindow(focusedWindowId);
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [
    closeSearch,
    focusedWindowId,
    isSearchOpen,
    openSearch,
    closeWindow,
    toggleAniAssistant,
  ]);
}
